(ns common.widgets.status
  (:require ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Typography$default" :as Typography]
            [uix.core :refer [$ defui]]))

(defui simple [{:keys [color status]}]
  ($ Stack {:direction "row" :gap 1 :alignItems "center"}
     ($ Icon
        {:sx #js {:color color
                  :fontSize "md"}}
        "circle")
     ($ Typography
        {:variant "button"
         :sx #js {:color color
                  :lineHeight "unset"}}
        status)))
